export default __webpack_public_path__ + "img/1abed22642b616a0763ccc79b5f22a82.svg";